export class getSiteHeaderInfoAction {
    public static readonly type = '[Design] GetSiteHeaderInfo';
    constructor() {}
}

export class setSiteHeaderInfoAction {
    public static readonly type = '[Design] SetSiteHeaderInfo';
    constructor(public data: any) {}
}
